import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const styles = {
  nav: {
    display: 'flex', alignItems: 'center', height: 56,
    padding: '0 2rem', backgroundColor: '#1e293b',
    borderBottom: '1px solid #334155', marginLeft: 260
  },
  breadcrumb: { fontSize: 13, color: '#64748b', display: 'flex', alignItems: 'center', gap: 6 },
  breadActive: { color: '#e2e8f0', fontWeight: 600 },
  right: { marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '1rem' },
  userBadge: {
    display: 'flex', alignItems: 'center', gap: '0.5rem',
    padding: '0.35rem 0.75rem', borderRadius: 8,
    backgroundColor: '#334155', fontSize: 12, color: '#cbd5e1', fontWeight: 500
  },
  avatar: {
    width: 26, height: 26, borderRadius: '50%',
    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 11, fontWeight: 700, color: '#fff'
  },
  btn: {
    backgroundColor: 'transparent', border: '1px solid #475569',
    color: '#94a3b8', padding: '0.35rem 0.75rem', borderRadius: 6,
    cursor: 'pointer', fontSize: 12, fontWeight: 500,
    transition: 'all 0.15s'
  }
};

function getBreadcrumb(pathname) {
  if (pathname === '/dashboard') return [{ label: 'Dashboard' }];
  if (pathname.startsWith('/projet/')) return [
    { label: 'Projets', path: '/dashboard' },
    { label: 'Detail' }
  ];
  return [{ label: 'SIGEPRO' }];
}

export default function Navbar({ user, onDeconnexion }) {
  const navigate = useNavigate();
  const location = useLocation();
  const crumbs = getBreadcrumb(location.pathname);

  const deconnexion = () => {
    localStorage.removeItem('sigepro_token');
    if (onDeconnexion) onDeconnexion();
    navigate('/connexion');
  };

  const initiales = user ? user.nom.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : '?';

  return (
    <nav style={styles.nav}>
      <div style={styles.breadcrumb}>
        {crumbs.map((c, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span style={{ color: '#475569' }}>/</span>}
            {c.path ? (
              <span
                style={{ cursor: 'pointer', color: '#64748b' }}
                onClick={() => navigate(c.path)}
              >
                {c.label}
              </span>
            ) : (
              <span style={styles.breadActive}>{c.label}</span>
            )}
          </React.Fragment>
        ))}
      </div>

      <div style={styles.right}>
        {user && (
          <>
            <div style={styles.userBadge}>
              <div style={styles.avatar}>{initiales}</div>
              {user.nom}
            </div>
            <button style={styles.btn} onClick={deconnexion}>
              Deconnexion
            </button>
          </>
        )}
      </div>
    </nav>
  );
}
